import { TripRead } from 'src/common/external/bambi-api/bambiApi';
import { SeatEquipmentBadge } from 'src/features/trip/management/SeatEquipmentBadge';

interface TripDetailsSeatEquipmentProps {
  tripData?: TripRead;
}
export function TripDetailsSeatEquipment({
  tripData,
}: TripDetailsSeatEquipmentProps) {
  const seatEquipment = tripData?.seat_equipment;

  if (!seatEquipment) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1 py-2">
      <h4 className="text-sm font-bold">Seat Equipment</h4>
      <div>
        <SeatEquipmentBadge seatEquipment={seatEquipment} />
      </div>
    </div>
  );
}
